<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >

    <!-- Content Left -->
    <b-col
      class="content-header-left"
      cols="12"
      md="12"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h3
            data-testid="title-page-in-top"
            class="content-header-title float-left pr-1 mb-0"
            :class="{'border-right-0': notShowBorderRight}"
          >
            {{ getTitle() }}
          </h3>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <!-- <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item> -->
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right -->
    <!--    <b-col-->
    <!--      class="content-header-right text-md-right d-md-block d-none mb-1"-->
    <!--      md="3"-->
    <!--      cols="12"-->
    <!--    />-->
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
  },

  mixins: [generalConfigsMixin],

  computed: {
    notShowBorderRight() {
      return !this.$route.meta.breadcrumb || this.$route.meta.breadcrumb.length === 0
    },
  },

  methods: {
    getTitle() {
      const hasStepGuide = JSON.parse(localStorage.getItem('isHasOnboardingStep'))

      if (hasStepGuide) {
        if (window.location.pathname === '/my-ads-account') {
          return this.$t('stepGuideControl.titleGetTikTokAgency')
        } if (window.location.pathname === '/payment/add-fund') {
          return this.isSetupCostModel ? this.$t('stepGuideControl.textSetupCost') : this.$t('stepGuideControl.textAddFund')
        }
      }
      return this.$route.meta.pageTitle
    },
  },
}
</script>
